<template>
  <div>
    <button
      :class="buttonClasses"
      @click="handleCopy"
      v-b-tooltip.click="tooltipText"
    >
      {{ buttonText }}
    </button>

    <!-- Success Popup -->
    <SuccessPopup
      :show="showSuccessPopup"
      :message="successMessage"
      @close="showSuccessPopup = false"
    />

    <!-- Error Popup -->
    <ErrorPopup
      :show="showErrorPopup"
      title="複製失敗！"
      :description="errorMessage"
      @close="showErrorPopup = false"
    />
  </div>
</template>

<script>
import SuccessPopup from '@/components/Page/Web/PartnerMarketing/SuccessPopup.vue'
import ErrorPopup from '@/components/Page/Web/PartnerMarketing/ErrorPopup.vue'

export default {
  name: 'CopyButton',
  components: { SuccessPopup, ErrorPopup },
  props: {
    text: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: '複製'
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'logs', 'barcode'].includes(value)
    },
    tooltipText: {
      type: String,
      default: '已複製'
    },
    successMessage: {
      type: String,
      default: '已複製到剪貼簿'
    }
  },
  data() {
    return {
      showSuccessPopup: false,
      showErrorPopup: false,
      errorMessage: ''
    }
  },
  computed: {
    buttonClasses() {
      const baseClasses = {
        'primary': 's-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3',
        'logs': 's-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3',
        'barcode': 'barcode-copy-btn'
      }
      return baseClasses[this.variant] || baseClasses.primary
    }
  },
  methods: {
    async handleCopy() {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.text)
        } else {
          // 降級方案
          const textArea = document.createElement('textarea')
          textArea.value = this.text
          document.body.appendChild(textArea)
          textArea.select()
          document.execCommand('copy')
          document.body.removeChild(textArea)
        }

        this.$emit('copied', this.text)
        this.showSuccessPopup = true
      } catch (error) {
        console.error('複製失敗:', error)
        this.errorMessage = '複製失敗，請手動複製'
        this.showErrorPopup = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.barcode-copy-btn {
  background: #FE577F;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}
</style>